module.exports = __webpack_public_path__ + "static/fonts/SourceHanSansCN-Regular.11c302d.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SourceHanSansCN-Regular.otf
// module id = jXfa
// module chunks = 71